[
  { "device": "iPhone 16 Pro Max, 17 Pro Max", "width": 440, "height": 956, "ratio": 3 },
  { "device": "iPhone Air", "width": 420, "height": 912, "ratio": 3 },
  { "device": "iPhone 16 Pro, 17, 17 Pro", "width": 402, "height": 874, "ratio": 3 },
  { "device": "iPhone 14 Pro Max, 15 Plus, 15 Pro Max, 16 Plus", "width": 430, "height": 932, "ratio": 3 },
  { "device": "iPhone 14 Pro, 15, 15 Pro, 16", "width": 393, "height": 852, "ratio": 3 },
  { "device": "iPhone 12 Pro Max, 13 Pro Max, 14 Plus", "width": 428, "height": 926, "ratio": 3 },
  { "device": "iPhone 12, 12 Pro, 13, 13 Pro, 14, 16e", "width": 390, "height": 844, "ratio": 3 },
  { "device": "iPhone X, XS, 11 Pro, 12 mini, 13 mini", "width": 375, "height": 812, "ratio": 3 },
  { "device": "iPhone XS Max, 11 Pro Max", "width": 414, "height": 896, "ratio": 3 },
  { "device": "iPhone XR, 11", "width": 414, "height": 896, "ratio": 2 },
  { "device": "iPhone 6s Plus, 7 Plus, 8 Plus", "width": 414, "height": 736, "ratio": 3 },
  { "device": "iPhone 6s, 7, 8, SE (2nd/3rd gen)", "width": 375, "height": 667, "ratio": 2 },
  { "device": "iPhone SE (1st gen)", "width": 320, "height": 568, "ratio": 2 },
  { "device": "iPad Pro 13\" (M4), iPad Air 13\" (M2+)", "width": 1032, "height": 1376, "ratio": 2 },
  { "device": "iPad Pro 12.9\"", "width": 1024, "height": 1366, "ratio": 2 },
  { "device": "iPad Pro 11\" (M4)", "width": 834, "height": 1210, "ratio": 2 },
  { "device": "iPad Pro 11\" (1st-4th gen)", "width": 834, "height": 1194, "ratio": 2 },
  { "device": "iPad Air 10.9\"/11\", iPad 10th gen+", "width": 820, "height": 1180, "ratio": 2 },
  { "device": "iPad Air 10.5\", iPad Pro 10.5\"", "width": 834, "height": 1112, "ratio": 2 },
  { "device": "iPad 10.2\"", "width": 810, "height": 1080, "ratio": 2 },
  { "device": "iPad mini 6+", "width": 744, "height": 1133, "ratio": 2 },
  { "device": "iPad 9.7\", iPad mini 4/5", "width": 768, "height": 1024, "ratio": 2 }
]
